module.exports = __webpack_public_path__ + "static/media/Outlook-WK.aeae2873.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/Outlook-WK.jpg
// module id = 1339
// module chunks = 1